export function filter(filter) {
    const $filter = filter;
    const $filterTitle = filter.find(".checkbox-list-title");
    const $moreBtn = filter.find(".more-filters-btn");
    const $filterItems = filter.find("input");
    const maxItems = 4;
    function init() {
        setDefaultValues();
        setEvents();
    }
    function setEvents() {
        $filterTitle.on("click", function () {
            if ($filter.hasClass("hide")) {
                $filter.removeClass("hide");
            } else {
                $filter.addClass("hide");
                hideFilters();
            }
        });
        $moreBtn.on("click", function (e) {
            e.preventDefault();
            if ($(this).hasClass("hide")) {
                hideFilters();
            } else {
                showAllFilters();
            }
        });
        $filterItems.on("click", function () {
            controllCheckedInput(this);
        });
    }
    function controllCheckedInput(input) {
        const $input = $(input);
        const index = $filterItems.index($input);

        if (index === 0) {
            $input.prop("checked", true);
            $filterItems.not(input).prop("checked", false);
            return;
        }
        if (input.checked) {
            $filterItems.eq(0).prop("checked", false);
        } else if ($filterItems.filter(":checked").length === 0) {
            $filterItems.eq(0).prop("checked", true);
        }
    }
    function setDefaultValues() {
        if ($filterItems.length <= maxItems) {
            $moreBtn.css("display", "none");
        } else {
            hideFilters();
        }
    }
    function showAllFilters() {
        $moreBtn.addClass("hide");
        $filterItems.removeClass("hide");
    }
    function hideFilters() {
        $moreBtn.removeClass("hide");
        $filterItems.slice(maxItems).addClass("hide");
    }
    return init();
}



// WEBPACK FOOTER //
// ./assets/js/modules/filter.js